import PosthogService from '~/services/posthog/PosthogService';

/**
 * Fires when the "Shift Details" step of the OLD Shift Request form is viewed
 * Event: dental_portal:shift_request_v0:shift_details_viewed
 */
export function fireV0ShiftDetailsPageViewed(): void {
  PosthogService.getInstance().track('dental_portal:shift_request_v0:shift_details_viewed');
}
